import {
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAIL,
  FETCH_LATEST_ORDERS_SUCCESS,
  FETCH_LATEST_ORDERS_FAIL,
  FETCH_OPEN_ORDERS_SUCCESS,
  FETCH_OPEN_ORDERS_FAIL,
  FETCH_ORDER_LIQUIDITY_SUCCESS,
  CREATE_ORDERS_SUCCESS,
  CREATE_ORDERS_FAIL,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAIL,
  FETCH_EXCHANGE_RATE_SUCCESS,
  FETCH_EXCHANGE_RATE_FAIL,
  FETCH_ASSET_VALUE_SUCCESS,
  FETCH_ASSET_VALUE_FAIL,
  FETCH_QUOTE_SUCCESS,
  FETCH_QUOTE_FAIL,
  CREATE_OTC_ORDER_SUCCESS,
  CREATE_OTC_ORDER_FAIL,
  FETCH_TST_QUOTE_SUCCESS,
  FETCH_TST_QUOTE_FAIL,
  CREATE_TST_ORDER_SUCCESS,
  CREATE_TST_ORDER_FAIL,
  FETCH_TST_SUPPLY_SUCCESS,
  FETCH_TST_SUPPLY_FAIL,
  FETCH_TST_ASSET_VALUE_SUCCESS,
  FETCH_TST_ASSET_VALUE_FAIL,
} from '../actions/types';

const initialState = {
  orders: [],
  liquidity: {},
  open: [],
  latest: [],
  errors: [],
  success: [],
  exchange: {},
  quote: {},
  assetValue: {},
  tstSupply: {},
};

const order = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_LIQUIDITY_SUCCESS: {
      let obj = { ...state };
      obj.liquidity[action.typeHandle] = action.payload;
      return obj;
    }
    case CREATE_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload,
        success: { success: ['Order successfully placed'] },
        errors: [],
        loading: false,
      };
    case CREATE_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
        success: [],
      };
    case DELETE_ORDER_SUCCESS:
      return {
        ...state,
        success: action.payload,
        loading: false,
      };
    case DELETE_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload,
        loading: false,
      };
    case FETCH_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_LATEST_ORDERS_SUCCESS:
      return {
        ...state,
        latest: action.payload,
        loading: false,
      };
    case FETCH_LATEST_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_OPEN_ORDERS_SUCCESS:
      return {
        ...state,
        open: action.payload,
        loading: false,
      };
    case FETCH_OPEN_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_EXCHANGE_RATE_SUCCESS:
      return {
        ...state,
        exchange: action.payload,
        loading: false,
      };
    case FETCH_EXCHANGE_RATE_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_ASSET_VALUE_SUCCESS:
      return {
        ...state,
        assetValue: action.payload.data,
        loading: false,
      };
    case FETCH_ASSET_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_QUOTE_SUCCESS:
      return {
        ...state,
        quote: action.payload,
        loading: false,
      };
    case FETCH_QUOTE_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case CREATE_OTC_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload,
        loading: false,
      };
    case CREATE_OTC_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_TST_QUOTE_SUCCESS:
      return {
        ...state,
        quote: action.payload,
        loading: false,
      };
    case FETCH_TST_QUOTE_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case CREATE_TST_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload,
        loading: false,
      };
    case CREATE_TST_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_TST_SUPPLY_SUCCESS:
      return {
        ...state,
        tstSupply: action.payload,
        loading: false,
      };
    case FETCH_TST_SUPPLY_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_TST_ASSET_VALUE_SUCCESS:
      return {
        ...state,
        tstAssetValue: action.payload.data,
        loading: false,
      };
    case FETCH_TST_ASSET_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    default:
      return state;
  }
};

export default order;
